export const bannerQueryKeys = {
  publicBannerKey: () => ['public-banner'],
  adminBannerKey: () => ['admin-banner'],
}
